var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArrows(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 33,
    viewBox: "0 0 35 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 18.0381,
    width: 3.43598,
    height: 35,
    transform: "rotate(-90 0 18.0381)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28.7051,
    y: 15.0457,
    width: 3.39714,
    height: 3.38915,
    transform: "rotate(-90 28.7051 15.0457)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25.8008,
    y: 12.1355,
    width: 3.39714,
    height: 3.38915,
    transform: "rotate(-90 25.8008 12.1355)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 22.8965,
    y: 9.22534,
    width: 3.39714,
    height: 3.38915,
    transform: "rotate(-90 22.8965 9.22534)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 19.9902,
    y: 6.30933,
    width: 3.39714,
    height: 3.38915,
    transform: "rotate(-90 19.9902 6.30933)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 17.0859,
    y: 3.39722,
    width: 3.39714,
    height: 3.38915,
    transform: "rotate(-90 17.0859 3.39722)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 28.7051,
    y: 21.3542,
    width: 3.39714,
    height: 3.38915,
    transform: "rotate(-90 28.7051 21.3542)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 25.8008,
    y: 24.2664,
    width: 3.39714,
    height: 3.38915,
    transform: "rotate(-90 25.8008 24.2664)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 22.8965,
    y: 27.1765,
    width: 3.39714,
    height: 3.38915,
    transform: "rotate(-90 22.8965 27.1765)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 19.9902,
    y: 30.0886,
    width: 3.39714,
    height: 3.38915,
    transform: "rotate(-90 19.9902 30.0886)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 17.0859,
    y: 32.9988,
    width: 3.39714,
    height: 3.38915,
    transform: "rotate(-90 17.0859 32.9988)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrows);
export default __webpack_public_path__ + "static/media/icon--arrows.a3a3f99c.svg";
export { ForwardRef as ReactComponent };